<template>
	<div id="dashboard" class="page">
		<div class="columns is-desktop" v-if="accountStatuses && userCan('view_accounts_summary_metric', 'metric')">
			<div class="column is-12-tablet is-5-desktop">
				<div class="tile is-ancestor">
					<doughnut-metric
						metricSize="is-12"
						route="accounts"
						filter="status"
						metric="accounts/summary" />
				</div>
			</div>
			<div class="column is-12-tablet is-7-desktop">
				<div class="tile is-ancestor">
					<totals-metric
						metricSize="is-12"
						metric="init/summary" />
				</div>
			</div>
		</div>

		<favorites />
		<invited />
		<recently-active />
		<router-view />
	</div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from 'vuex'
import RecentlyActive from './Account/Dashboard/RecentlyActive'
import Favorites from './Account/Dashboard/Favorites'
import Invited from './Account/Dashboard/Invited'
import DoughnutMetric from './Metrics/DoughnutMetric'
import TotalsMetric from './Metrics/TotalsMetric'

export default {
  components: {
    RecentlyActive,
    Favorites,
    Invited,
    DoughnutMetric,
    TotalsMetric
  },
  data () {
    return {
      accountId: this.$route.params.id
    }
  },
  computed: {
    ...mapState({
      accounts: state => state.accounts.recent,
      anyAccounts: state => state.accounts.any,
      accountStatuses: state => state.accounts.statusCounts,
      modelUpdatedAt: state => state.modelUpdatedAt,
      dataChanged: state => state.dataChanged
    }),
    ...mapGetters({
      pusher: 'pusher/init',
      userCan: 'userCan'
    }),
    pusherChannel: function () {
      if (!this.pusher) return
      return this.pusher.subscribe('private-datatable.accounts')
    },
    hasAccounts: function () {
      return Object.keys(this.accounts).length > 0
    }
  },
  watch: {
    modelUpdatedAt: function () {
      if (this.dataChanged === 'data') {
        this.$store.dispatch('accounts/getRecentlyActiveAccounts')
        this.$store.dispatch('accounts/getFavoriteAccounts')
        this.$store.dispatch('accounts/getInvitedAccounts')
      }
    },
    hasAccounts: function (newVal, oldVal) {
      if (newVal === true && oldVal === false) {
        this.getExtraData()
      }
    }
  },
  methods: {
    ...mapMutations([
      'setPageTitle'
    ]),
    getExtraData () {
      this.$store.dispatch('accounts/getStatusCounts')
      this.$store.dispatch('accounts/getAccountStatuses')
    },
    getData () {
      this.$store.dispatch('accounts/getRecentlyActiveAccounts')
      this.$store.dispatch('accounts/getFavoriteAccounts')
      this.$store.dispatch('accounts/getInvitedAccounts')
      if (this.hasAccounts) this.getExtraData()
    }
  },
  created () {
    this.setPageTitle('Dashboard')
    this.getData()
  },
  mounted () {
    if (!this.pusher) return
    this.pusherChannel.bind('model-updated', (data) => {
      let local = new Date(this.modelUpdatedAt)
      let pusher = new Date(data.updatedAt)

      if (pusher.getTime() > local.getTime()) {
        this.getData()
      }
    })
  },
  beforeDestroy () {
    if (this.pusher) {
      this.pusher.unsubscribe('private-datatable.accounts')
      this.pusherChannel.unbind('model-updated')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Dashboard.vue